export const shouldRunExperiments = (publisherClientId = '') => {
    const whitelist = [
        '616dOp',
        'wgkDkv',
        'e5xEQo',
        'oy8jJ5',
        'vVO725',
        'gldzzg',
        'oBWAag', // 2654 americansongwriter.com article grid
    ];
    return whitelist.includes(publisherClientId);
};
export const parseExperiments = (experiments, publisherClientId = '') => {
    // Map experiment name to experiment response
    const parsedExperiments = {};
    experiments.forEach((exp) => {
        parsedExperiments[exp.name] = exp;
    });
    return {
        experiments: parsedExperiments,
        params: parseAutoplayExperiment(parsedExperiments, publisherClientId),
    };
};
const parseAutoplayExperiment = (experiments, publisherClientId = '') => {
    var _a;
    const names = {
        wgkDkv: 'prod_autoplay_5',
        e5xEQo: 'prod_autoplay_6',
        oy8jJ5: 'prod_autoplay_7',
        vVO725: 'prod_autoplay_8',
        gldzzg: 'prod_autoplay_9',
        oBWAag: 'prod_autoplay_10',
    };
    const experimentName = names[publisherClientId];
    if (experiments[experimentName]) {
        return {
            autoplay: ((_a = experiments[experimentName]) === null || _a === void 0 ? void 0 : _a.variant) === 'on',
        };
    }
    return {};
};
